import { warn } from '@helsenorge/framework-utils/logger';
import { setAdobeAnalyticsConsent } from './analytics';
import { saveCookieConsentCookie } from './cookie';
import { HNeventCookieConsentChange } from './events';
/**
 * Logg endring i brukerens cookie-samtykker
 * @param options Brukerens cookie-samtykker
 */
export const logCookieConsentChange = (options) => {
    warn(`Informasjonskapsler for webanalyse er ${options.AnalyticsCookies ? 'godtatt' : 'ikke godtatt'}`);
};
/**
 * Lagre brukerens cookie-samtykker og oppdater eventuelt Adobe Opt-in Service slik at Adobe Analytics kan spore brukerens aktivitet.
 *
 * @param options Brukerens cookie-samtykker
 */
export const updateCookieConsent = (options) => {
    saveCookieConsentCookie(options);
    setAdobeAnalyticsConsent(options);
    logCookieConsentChange(options);
    HNeventCookieConsentChange(options);
};
